module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notes wrapper"
  }, [_c('h6', {
    staticClass: "dark fs-small bold"
  }), _vm._v(" "), _c('div', {
    staticClass: "my-3"
  }, [(_vm.getEventNotes) ? _c('ul', [(_vm.event.product && _vm.event.product.internalNote) ? _c('li', {
    staticClass: "d-flex mb-2 relative"
  }, [_vm._v(_vm._s(_vm.event.product.internalNote))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getEventNotes), function(note) {
    return _c('li', {
      staticClass: "d-flex mb-2 relative"
    }, [_c('div', {
      staticClass: "flex-all",
      on: {
        "mouseenter": _vm.showActions,
        "mouseleave": _vm.hideActions
      }
    }, [_c('i', {
      staticClass: "ico-alert color-6 largest"
    }), _vm._v("\n                    " + _vm._s(note.note) + "\n\n                    "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.actions) ? _c('div', {
      staticClass: "actions"
    }, [_c('i', {
      staticClass: "ico-edit pointer larger medium",
      on: {
        "click": function($event) {
          return _vm.editNote(note)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "ico-delete pointer larger medium",
      on: {
        "click": function($event) {
          return _vm.deleteNote(note)
        }
      }
    })]) : _vm._e()])], 1)])
  })], 2) : _c('div', [_vm._v("\n            You don't have notes.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "new dark pointer d-flex align-items-center",
    on: {
      "click": _vm.addNote
    }
  }, [_c('span', {
    staticClass: "ico-add color-1 mr-1 rounded-circle border-color-1 p-1 addNoteIcon"
  }), _vm._v("\n        Add note\n    ")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-74dbfd32", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74dbfd32"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/EventNotes.vue
// module id = 2660
// module chunks = 0